export const PRICING_CONFIG = {
    tops: {
        RectangleTop: {
            basePrice: 5909,
            compoundingRate: 0.05,
            pricingStep: 6
        },
        SquareTop: {
            basePrice: 5241,
            compoundingRate: 0.05,
            pricingStep: 6
        },
        RoundTop: {
            basePrice: 3801,
            compoundingRate: 0.05,
            pricingStep: 6
        },
        EllipticalOvalTop: {
            basePrice: 6195,
            compoundingRate: 0.05,
            pricingStep: 6
        },
        RacetrackOvalTop: {
            basePrice: 6195,
            compoundingRate: 0.05,
            pricingStep: 6
        },
        BoatShapeTop: {
            basePrice: 6195,
            compoundingRate: 0.05,
            pricingStep: 6
        }
    },
    bases: {
        // Pedestal
        AnchorBase: 0,
        AnchorSingleFeetBase: 0,
        AnchorSinglePlatformBase: 0,
        BellhouseBase: 0,
        BellhouseSingleFeetBase: 0,
        BellhouseSinglePlatformBase: 0,
        BellyStretchedBase: 0,
        BrewerBase: 0,
        BrewerSingleBase: 0,
        CaseyBase: 0,
        CraftsmanBase: 0,
        CraftsmanSingleBase: 0,
        CrescentBase: 0,
        CrescentSingleBase: 0,
        DanaBase: 0,
        DanaSingleBase: 0,
        FranklinBase: 0,
        FranklinSingleFeetBase: 0,
        FranklinSinglePlatformBase: 0,
        MarksBase: 0,
        MeredithBase: 0,
        MeredithSingleFeetBase: 0,
        MeredithSinglePlatformBase: 0,
        OswaldBase: 0,
        OswaldSingleBase: 0,
        PeruStretchedBase: 0,
        RishBase: 0,
        RishSingleBase: 0,
        RogersBase: 0,
        RogersSinglePlatformBase: 0,
        TamaraBase: 0,
        TamaraSingleBase: 0,
        TuscanBase: 0,
        TuscanSingleFeetBase: 0,
        TuscanSinglePlatformBase: 0,
        WaldenBase: 0,
        WaldenSingleBase: 0,
        XBase: 0,
        XSingleBase: 0,
        // Metal
        AnglePictureFrameBase: 0,
        AnglePictureFrameSingleBase: 0,
        AnglePictureFrameCTCBase: 0,
        ArchBase: 0,
        ArchSingleBase: 0,
        BoxFrameBase: 0,
        MantisBase: 0,
        ConnectedXBase: 0,
        SlimConnectedXBase: 0,
        SlimConnectedXSingleBase: 0,
        ReflectionBase: 0,
        ReflectionCTCBase: 0,
        SinglePostBase: 0,
        SinglePostSingleBase: 0,
        XMetalBase: 0,
        XMetalSingleBase: 0,
        ReededBase: 0,
        // Four Leg
        IvyBase: 0,
        DremorTurnedBase: 0,
        HerricksonTurnedBase: 0,
        MidModernTaperBase: 0,
        NarrowEnglishTurnedBase: 0,
        OldEnglishTurnedBase: 0,
        SlagleTurnedBase: 0,
        TraditionalBase: 0,
        TraditionalFlushBase: 0
    },
    thickness: {
        Standard: 0,
        Thick: 468,
        Rolled: 468
    },
    edgeStyles: {
        Clean: 0,
        NaturalWavy: 0,
        Tumbled: 0,
        Dupont: 209,
        Beveled: 209
    },
    leaves: {
        NoLeaf: 0,
        Standard: 753,
        Medium: 823,
        Large: 894,
        Perimeter: 1880,
        StandardDropIn: 1003,
        MediumDropIn: 1073,
        LargeDropIn: 1144,
        CustomLeaf: 0
    },
    woodSpecies: {
        Hickory: 0,
        Ash: 0,
        Maple: 0.14,
        Walnut: 0.24,
        QuarterSawnWhiteOak: 0.35
    },
    aprons: {
        ApronNone: 0,
        ApronBasic: 0
    },
    seating: {
        NoSeating: 0,
        Benches: 955,
        Chairs: 0,
        ChairsAndBenches: 0
    },
    distressLevels: {
        Clean: 0,
        Minimal: 0,
        Light: 0,
        Medium: 0,
        Heavy: 0,
        RoughSawn: 0
    },
    finishes: {
        BlackTone: 0,
        EbonyTone: 0,
        Gray: 0,
        DarkBrownTone: 0,
        MediumBrownTone: 0,
        LightBrownTone: 0,
        NaturalTone: 0,
        Earthtone: 0,
        Taupe: 0,
        Custom: 0
    },
    sheens: {
        Flat: 0,
        Satin: 0
    },
    grooves: 0,
    cornerRadius: 0,
    crossbrace: 0
};

//# sourceMappingURL=pricing-config.js.map